import { Injectable } from '@angular/core';
import { BuildingListType } from '../enums/buildingListTypeEnum';

@Injectable()
export class LocalStorageService {

  constructor() {}

  readonly BUILDING_LIST_TYPE_TAG: string = 'BuildingListType';

  public setBuildingListType(value: BuildingListType) {
    localStorage.setItem(this.BUILDING_LIST_TYPE_TAG, value);
  }

  public getBuildingListType(): BuildingListType {
    return localStorage.getItem(this.BUILDING_LIST_TYPE_TAG) as BuildingListType;
  }
}
